import type { FC } from 'react'
import type { LucideIcon } from 'lucide-react'

import {
    Activity,
    HeartPulse,
    ShieldCheck,
    Sparkles,
    Stethoscope
} from 'lucide-react'

const ICONS: Record<string, LucideIcon> = {
    sparkles: Sparkles,
    'heart-pulse': HeartPulse,
    stethoscope: Stethoscope,
    'shield-check': ShieldCheck
}

interface HubIconProps {
    name: string
    className?: string
}

export const HubIcon: FC<HubIconProps> = ({ name, className }) => {
    const Icon = ICONS[name] ?? Activity

    return <Icon className={className} aria-hidden='true' />
}
